// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__7RteB","large":"Avatar_large__eK6J+","medium":"Avatar_medium__7CMpd","small":"Avatar_small__W7OHD"};